import { range } from 'lodash';
import { t } from '../../config/i18n';

export const defaultCurrency = 'USD';

export const defaultFeeCurrency = 'USD';

export const Currencies = {
  EUR: 'EUR',
  GBP: 'GBP',
  USD: 'USD',
};

export const HTTPCodes = {
  NOT_FOUND: 404,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
};
export const successStatus = range(200, 300);

export const AuthKeys = {
  IS_AUTHENTICATED: 'isAuthenticated',
  LANGUAGE: 'language',
  AUTHORIZATION: 'authorization',
  ID_USER: 'idUser',
  USER_DATA: 'userData',
  REFERRER: 'referrer',
};

export const TransactionsStatus = {
  PENDING: 'PENDING',
  SETTLED: 'SETTLED',
  VALIDATED: 'VALIDATED',
  CANCELLED: 'CANCELLED',
  INVALID: 'INVALID',
  EXPIRED: 'EXPIRED',
  CAPTURED: 'CAPTURED',
  REJECTED: 'REJECTED',
  DECLINED: 'DECLINED',
  ERROR: 'ERROR',
  COMPLETED: 'COMPLETED',
  APPROVED: 'APPROVED',
  CLEARED: 'CLEARED',
  ON_HOLD: 'ON_HOLD',
  DELIVERED: 'DELIVERED',
  INCORRECT_DETAILS: 'INCORRECT_DETAILS',
  FOR_REVIEW: 'FOR_REVIEW',
  EARLY_RELEASE: 'EARLY_RELEASE',
  CREATED: 'CREATED',
  INITIATED: 'INITIATED',
  REFUNDED: 'REFUNDED',
  PENDING_REFUND: 'PENDING REFUND',
  COMPLETED_REFUND: 'COMPLETED REFUND',
  DELIVERED_REFUND: 'DELIVERED REFUND',
  CANCELLED_REFUND: 'CANCELLED REFUND',
  INCORRECT_DETAILS_REFUND: 'INCORRECT DETAILS REFUND',
  REJECTED_REFUND: 'REJECTED REFUND',
};

export const InstallmentsReleasesStatus = {
  RELEASED: 'RELEASED',
  NEXT_RELEASE: 'NEXT_RELEASE',
  TO_RELEASE: 'TO_RELEASE',
};

export const reasons = {
  UNMATCHED_DOCUMENT: 'UNMATCHED_DOCUMENT',
  CLIENT_REQUEST: 'CLIENT_REQUEST',
  PAYMENT_NOT_FOUND: 'PAYMENT_NOT_FOUND',
  BANK_NOT_REGULATED: 'BANK_NOT_REGULATED',
  UNMATCHED_BANK_ACCOUNT: 'UNMATCHED_BANK_ACCOUNT',
  OTHER: 'OTHER',
};

export const RefundReason = [
  { value: reasons.UNMATCHED_DOCUMENT, label: 'Unmatched document' },
  { value: reasons.CLIENT_REQUEST, label: 'Client Request' },
  { value: reasons.PAYMENT_NOT_FOUND, label: 'Payment not found' },
  { value: reasons.BANK_NOT_REGULATED, label: 'Bank not regulated' },
  { value: reasons.UNMATCHED_BANK_ACCOUNT, label: 'Unmatched bank account' },
  { value: reasons.OTHER, label: 'Other' },
];

export const ClientStatus = {
  BLACKLISTED: 'BLACKLISTED',
  GREYLISTED: 'GREYLISTED',
  BLOCKED: 'BLOCKED',
  SUSPENDED: 'SUSPENDED',
  ACTIVE: 'ACTIVE',
  WHITELISTED_BASIC: 'WHITELISTED_BASIC',
  WHITELISTED_FULL: 'WHITELISTED_FULL',
};

export const LimitStatus = {
  CRITICAL: 'CRITICAL',
};

export const PREFERRED_COUNTRIES = ['pe', 'br', 'ar', 'mx', 'cl', 'cn', 'co', 'uy', 'in'];

export const RecurringPaymentStatus = {
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING',
  CANCELLED: 'CANCELLED',
  SUSPENDED: 'SUSPENDED',
  TERMINATED: 'TERMINATED',
};

const PaymentMethodsStatus = {
  OK: 'OK',
  WARNING: 'WARNING',
  UNAVAILABLE: 'UNAVAILABLE',
};

export const TransactionTypeStatus = {
  CASH_IN: 'CASH_IN',
  CASH_OUT: 'CASH_OUT',
};

const TicketStatus = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
  IN_PROGRESS: 'IN_PROGRESS',
  RESOLVED: 'RESOLVED',
};

export const SettlementsStatus = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  READY: 'READY',
  OBSERVED: 'OBSERVED',
};

const AccountsStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
  DELETED: 'DELETED',
};

const BatchStatus = {
  STARTING: 'STARTING',
  PROCESSING: 'PROCESSING',
};

export const RefundPaymentTypes = {
  DEPOSIT: 'DEPOSIT',
  MANUAL: 'MANUAL',
  UNMATCHED: 'UNMATCHED',
};

export const SettlementsType = {
  MANUAL: 'MANUAL',
  SYSTEM: 'SYSTEM',
  SCHEDULED_BY_PERIOD: 'SCHEDULED_BY_PERIOD',
  SCHEDULED_BY_AMOUNT: 'SCHEDULED_BY_AMOUNT',
  SETTLEMENT_BY_BUSINESS_DAYS: 'SETTLEMENT_BY_BUSINESS_DAYS',
};

export const ticketTypes = {
  GENERIC: 'GENERIC',
  FLAG_FOR_REVIEW_DEPOSIT: 'FLAG_FOR_REVIEW_DEPOSIT',
  FLAG_FOR_REVIEW_DEPOSIT_CREATED: 'FLAG_FOR_REVIEW_DEPOSIT_CREATED',
  FLAG_FOR_REVIEW_WITHDRAWAL: 'FLAG_FOR_REVIEW_WITHDRAWAL',
  FLAG_FOR_REVIEW_WITHDRAWAL_CREATED: 'FLAG_FOR_REVIEW_WITHDRAWAL_CREATED',
  LIMIT_INCREASE: 'LIMIT_INCREASE',
  LIMIT_INCREASE_CREATED: 'LIMIT_INCREASE_CREATED',
  STATUS_CHANGE: 'STATUS_CHANGE',
  STATUS_CHANGE_CREATED: 'STATUS_CHANGE_CREATED',
  REQUEST_RECEIPT: 'REQUEST_RECEIPT',
  FLAG_FOR_REVIEW_NOTE: 'FLAG_FOR_REVIEW_NOTE',
  CHANGE_BANK_DETAILS: 'CHANGE_BANK_DETAILS',
};

export const iconTypes = {
  ERROR: { iconType: 'danger', iconName: 'exclamation-triangle' },
  INFO: { iconType: 'info', iconName: 'info-square' },
  WARNING: { iconType: 'warning', iconName: 'exclamation-circle' },
};

export const notifType = ['INFO', 'WARNING', 'ERROR'];

export const merchantBankAccountTypes = ['SEPA', 'SWIFT', 'BOTH'];

export const cryptoCurrencies = ['USDT', 'USDC', 'BTC'];

export const cryptoAddressTypes = ['BEP2', 'BEP20', 'BTC', 'ERC20', 'TRC20'];

export const RefundAmountTypes = {
  TOTAL: 'TOTAL',
  PARTIAL: 'PARTIAL',
};

export const SignUpRequestStatus = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  INTEGRATING: 'INTEGRATING',
  LIVE_REQUESTED: 'LIVE_REQUESTED',
  INTEGRATION_APPROVED: 'INTEGRATION_APPROVED',
  DECLINED: 'DECLINED',
};

export const VoucherStatus = {
  UPLOADED: 'UPLOADED',
  MERCHANT_DISCARDED: 'MERCHANT_DISCARDED',
  MERCHANT_ACCEPTED: 'MERCHANT_ACCEPTED',
};

export const paymentType = {
  BANK_TRANSFER: 'Bank transfer',
  BANK_DEPOSIT: 'Bank deposit',
  CREDIT_CARD: 'Credit card',
  VOUCHER: 'Cash',
  CASH: 'APM',
};

export const AnonymousClients = {
  ANONYMOUS: 'ANONYMOUS',
};

export const TopUpStatus = {
  PENDING: 'PENDING',
  CANCELLED: 'CANCELLED',
  WAITING_TRANSFER: 'WAITING_TRANSFER',
  PARTIALLY_COMPLETED: 'PARTIALLY_COMPLETED',
  COMPLETED: 'COMPLETED',
};

export const statusMappingBatch = {
  0: 'CREATED',
  1: 'PENDING',
  2: 'CONFIRMED',
  3: 'PROCESSING',
  4: 'COMPLETED',
  5: 'CANCELLED',
};

export const statusMappingOrder = {
  0: 'CREATED',
  1: 'TO_REVIEW',
  2: 'PENDING',
  3: 'PROCESSING_PAYMENT',
  4: 'PAID',
  5: 'CANCELLED',
  6: 'EXPIRED',
  7: 'REJECTED',
};

export const CollectionsManagement = {
  CREATED: 'CREATED',
  TO_REVIEW: 'TO_REVIEW',
  PENDING: 'PENDING',
  PROCESSING_PAYMENT: 'PROCESSING_PAYMENT',
  PAID: 'PAID',
  COMPLETED: 'COMPLETED',
  EXPIRED: 'EXPIRED',
  CANCELLED: 'CANCELLED',
  CONFIRMED: 'CONFIRMED',
  REJECTED: 'REJECTED',
};

export const Status = {
  ...TransactionsStatus,
  ...ClientStatus,
  ...PaymentMethodsStatus,
  ...TransactionTypeStatus,
  ...TicketStatus,
  ...TransactionTypeStatus,
  ...SettlementsStatus,
  ...SettlementsType,
  ...AccountsStatus,
  ...RefundAmountTypes,
  ...LimitStatus,
  ...SignUpRequestStatus,
  ...BatchStatus,
  ...RefundPaymentTypes,
  ...VoucherStatus,
  ...AnonymousClients,
  ...TopUpStatus,
  ...RecurringPaymentStatus,
  ...InstallmentsReleasesStatus,
  ...CollectionsManagement,
};

export const AccountsStatusListInternal = [
  { value: Status.ACTIVE, label: 'Active' },
  { value: Status.BLOCKED, label: 'Blocked' },
  { value: Status.INACTIVE, label: 'Inactive' },
  { value: Status.DELETED, label: 'Deleted' },
];
export const AccountsStatusList = [
  { value: Status.ACTIVE, label: 'Active' },
  { value: Status.BLOCKED, label: 'Blocked' },
  { value: Status.INACTIVE, label: 'Inactive' },
];

export const ClientStatusSelect = [
  { value: Status.ACTIVE, label: 'Active' },
  { value: Status.BLACKLISTED, label: 'Blacklisted' },
  { value: Status.GREYLISTED, label: 'Greylisted' },
  { value: Status.BLOCKED, label: 'Blocked' },
  { value: Status.SUSPENDED, label: 'Suspended' },
  { value: Status.WHITELISTED_BASIC, label: 'WhitelistedBasic' },
  { value: Status.WHITELISTED_FULL, label: 'WhitelistedFull' },
];

export const AttachmentStatus = {
  REQUIRED: 'REQUIRED',
  OPTIONAL: 'OPTIONAL',
  LOADING: 'LOADING',
  LOADED: 'LOADED',
  ERROR: 'ERROR',
};

export const SignUpRequestSelectStatus = [
  { value: Status.PENDING, label: 'Pending' },
  { value: Status.ACCEPTED, label: 'Accepted' },
  { value: Status.INTEGRATING, label: 'Integrating' },
  { value: Status.LIVE_REQUESTED, label: 'LiveRequested' },
  { value: Status.INTEGRATION_APPROVED, label: 'IntegrationApproved' },
  { value: Status.DECLINED, label: 'Declined' },
];

export const CashInStatus = [
  { value: Status.CREATED, label: 'Created' },
  { value: Status.INITIATED, label: 'Initiated' },
  { value: Status.PENDING, label: 'Pending' },
  { value: Status.EARLY_RELEASE, label: 'EarlyRelease' },
  { value: Status.APPROVED, label: 'Approved' },
  { value: Status.COMPLETED, label: 'Completed' },
  { value: Status.EXPIRED, label: 'Expired' },
  { value: Status.CANCELLED, label: 'Cancelled' },
  { value: Status.DECLINED, label: 'Declined' },
  { value: Status.FOR_REVIEW, label: 'ForReview' },
];

export const PaymentOrdersStatus = [
  { value: Status.CREATED, label: 'Created' },
  { value: Status.TO_REVIEW, label: 'To Review' },
  { value: Status.PENDING, label: 'Pending' },
  { value: Status.PROCESSING_PAYMENT, label: 'Processing Payment' },
  { value: Status.PAID, label: 'Paid' },
  { value: Status.COMPLETED, label: 'Completed' },
  { value: Status.EXPIRED, label: 'Expired' },
  { value: Status.CANCELLED, label: 'Cancelled' },
];

export const PaymentBatchOrdersStatus = [
  { value: Status.CREATED, label: 'Created' },
  { value: Status.PENDING, label: 'Pending' },
  { value: Status.CONFIRMED, label: 'Confirmed' },
  { value: Status.PROCESSING, label: 'Processing' },
  { value: Status.COMPLETED, label: 'Completed' },
  { value: Status.CANCELLED, label: 'Cancelled' },
];

export const RecurringPaymentsStatus = [
  { value: Status.ACTIVE, label: 'Active' },
  { value: Status.PENDING, label: 'Pending' },
  { value: Status.CANCELLED, label: 'Cancelled' },
  { value: Status.TERMINATED, label: 'Terminated' },
];

export const CashOutStatus = [
  { value: Status.PENDING, label: 'Pending' },
  { value: Status.DELIVERED, label: 'Delivered' },
  { value: Status.COMPLETED, label: 'Completed' },
  { value: Status.CANCELLED, label: 'Cancelled' },
  { value: Status.REJECTED, label: 'Rejected' },
  { value: Status.ON_HOLD, label: 'OnHold' },
  { value: Status.DECLINED, label: 'Declined' },
];

export const RefundStatus = [
  { value: Status.PENDING, label: 'Pending' },
  { value: Status.DELIVERED, label: 'Delivered' },
  { value: Status.INCORRECT_DETAILS, label: 'IncorrectDetails' },
  { value: Status.COMPLETED, label: 'Completed' },
  { value: Status.CANCELLED, label: 'Cancelled' },
  { value: Status.REJECTED, label: 'Rejected' },
  { value: Status.DECLINED, label: 'Declined' },
];

export const RefundTypes = [
  { value: Status.DEPOSIT, label: 'Deposit' },
  { value: Status.MANUAL, label: 'Manual' },
  { value: Status.UNMATCHED, label: 'Unmatched' },
];

export const ChargebackStatus = [
  { value: Status.PENDING, label: 'Pending' },
  { value: Status.COMPLETED, label: 'Completed' },
  { value: Status.CANCELLED, label: 'Cancelled' },
];

export const AllTransactionsStatus = [
  { value: Status.PENDING, label: 'Pending' },
  { value: Status.COMPLETED, label: 'Completed' },
  { value: Status.CANCELLED, label: 'Cancelled' },
];

export const AllPaymentMethodsStatus = [
  { value: Status.OK, label: 'Ok' },
  { value: Status.WARNING, label: 'Warning' },
  { value: Status.UNAVAILABLE, label: 'Unavailable' },
];

export const SettlementsHistoryStatus = [
  { value: Status.PENDING, label: 'Pending' },
  { value: Status.COMPLETED, label: 'Completed' },
  { value: Status.CANCELLED, label: 'Cancelled' },
  { value: Status.FAILED, label: 'Failed' },
];

export const SupportStatus = [
  { value: Status.OPEN, label: 'Open' },
  { value: Status.CLOSED, label: 'Closed' },
  { value: Status.IN_PROGRESS, label: 'InProgress' },
  { value: Status.RESOLVED, label: 'Resolved' },
];

export const BatchStatusSelect = [
  { value: Status.STARTING, label: 'Starting' },
  { value: Status.PROCESSING, label: 'Processing' },
  { value: Status.COMPLETED, label: 'Completed' },
];

export const TranfersStatus = [
  { value: Status.PENDING, label: 'Pending' },
  { value: Status.COMPLETED, label: 'Completed' },
  { value: Status.REJECTED, label: 'Rejected' },
];

export const CommercialRelationshipStatus = [
  { value: Status.APPROVED, label: 'Approved' },
  { value: Status.REJECTED, label: 'Rejected' },
];
export const LocalStorageKeys = {
  cashInColumns: 'CASH_IN_COLUMNS',
  cashOutColumns: 'CASH_OUT_COLUMNS',
  allTransactionsColumns: 'ALL_TRANSACTIONS_COLUMNS',
};

export const transactionType = [
  { value: Status.CASH_IN, label: 'statusCashIn' },
  { value: Status.CASH_OUT, label: 'statusCashOut' },
];

export const userRoles = {
  KYC: 'KYC',
  ADMIN: 'ADMIN',
  FINANCE: 'FINANCE',
  COMMERCIAL: 'COMMERCIAL',
  SUPPORT: 'SUPPORT',
  SUPPORT_ADMIN: 'SUPPORT_ADMIN',
  LEGAL: 'LEGAL',
  OPERATIONS: 'OPERATIONS',
  IT: 'IT',
  AUDIT: 'AUDIT',
  COMPLIANCE: 'COMPLIANCE',
  OPERATIONS_ADMIN: 'OPERATIONS_ADMIN',
  FRAUD_RISK: 'FRAUD_RISK',
};

export const maxRowDataTable = 2000;
export const minColumnsDataTable = 3;
export const scrollThreshold = 60;
export const limitTicketsDashboard = 6;
export const companyName = 'Directa 24';

export const validateTokenDest = {
  SIGN_IN: '1',
  RESET_PASS: '2',
  RESET_MFA: '3',
};

export const amountConfig = {
  minimumFractionDigits: 2,
};

export const preferedMobileCountries = ['BR', 'AR', 'MX', 'CL', 'CN', 'CO', 'UY'];

export const languages = [
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Español' },
  { value: 'pt', label: 'Português' },
];

export const noteType = {
  GENERIC_CREDIT_NOTE: 'GENERIC_CREDIT_NOTE',
  SERVICE_FEE_CREDIT_NOTE: 'SERVICE_FEE_CREDIT_NOTE',
  CHARGEBACK_COVERED_CREDIT_NOTE: 'CHARGEBACK_COVERED_CREDIT_NOTE',
  GENERIC_DEBIT_NOTE: 'GENERIC_DEBIT_NOTE',
  REFUND: 'REFUND',
  REFUND_PROCESSING_FEE: 'REFUND_PROCESSING_FEE',
  CASHOUT_TRANSACTION: 'CASHOUT_TRANSACTION',
  CASHOUT_PROCESSING_FEE: 'CASHOUT_PROCESSING_FEE',
  CHARGEBACK: 'CHARGEBACK',
  CHARGEBACK_PROCESSING_FEE: 'CHARGEBACK_PROCESSING_FEE',
  SERVICE_FEE_DEBIT_NOTE: 'SERVICE_FEE_DEBIT_NOTE',
  EXCHANGE_CREDIT_NOTE: 'EXCHANGE_CREDIT_NOTE',
  EXCHANGE_DEBIT_NOTE: 'EXCHANGE_DEBIT_NOTE',
  EXCHANGE_FEE: 'EXCHANGE_FEE',
  TOP_UP_CREDIT_NOTE: 'TOP_UP_CREDIT_NOTE',
  FUTURE_SETTLEABLE_NOTE: 'FUTURE_SETTLEABLE_NOTE',
};

export const DebitNoteSelect = [
  { value: noteType.GENERIC_DEBIT_NOTE, label: 'Generic Debit Note' },
  { value: noteType.REFUND, label: 'Transaction Refund' },
  { value: noteType.REFUND_PROCESSING_FEE, label: 'Refund Processing Fee' },
  { value: noteType.CASHOUT_TRANSACTION, label: 'Cashout transaction' },
  { value: noteType.CASHOUT_PROCESSING_FEE, label: 'Cashout transaction Fee' },
  { value: noteType.CHARGEBACK, label: 'Chargeback' },
  {
    value: noteType.CHARGEBACK_PROCESSING_FEE,
    label: 'Chargeback Porcessing Fee',
  },
  {
    value: noteType.SERVICE_FEE_DEBIT_NOTE,
    label: 'Chargeback Covered Debit Note',
  },
  { value: noteType.EXCHANGE_CREDIT_NOTE, label: 'Exchange Credit Note' },
  { value: noteType.EXCHANGE_DEBIT_NOTE, label: 'Exchange Debit Note' },
  { value: noteType.EXCHANGE_FEE, label: 'Exchange Fee' },
  { value: noteType.FUTURE_SETTLEABLE_NOTE, label: 'Future Settleable Note' },
];

export const CreditNoteSelect = [
  { value: noteType.GENERIC_CREDIT_NOTE, label: 'Generic Credit Note' },
  { value: noteType.SERVICE_FEE_CREDIT_NOTE, label: 'Service Fee Credit Note' },
  {
    value: noteType.CHARGEBACK_COVERED_CREDIT_NOTE,
    label: 'Chargeback Covered Credit Note',
  },
  {
    value: noteType.FUTURE_SETTLEABLE_NOTE,
    label: 'Future Settleable Note',
  },
];

export const ticketTypeLabel = {
  FLAG_FOR_REVIEW_DEPOSIT: 'labelDepositId',
  FLAG_FOR_REVIEW_WITHDRAWAL: 'labelWithdrawalId',
  LIMIT_INCREASE: 'columnIdUser',
  STATUS_CHANGE: 'columnIdUser',
  REQUEST_RECEIPT: 'labelRequestID',
};

export const ignoredErrorMsg = ['Request failed with status code 401'];

const WithdrawalFeeResponsibleTypes = {
  MERCHANT: 'MERCHANT',
  CUSTOMER: 'CUSTOMER',
};

export const WithdrawalResponsible = [
  { value: WithdrawalFeeResponsibleTypes.MERCHANT, label: 'MERCHANT' },
  { value: WithdrawalFeeResponsibleTypes.CUSTOMER, label: 'CUSTOMER' },
];

export const MailGroupKeys = {
  DEPOSIT: 'DEPOSIT',
  WITHDRAWAL: 'WITHDRAWAL',
  CLIENT: 'CLIENT',
  GENERIC: 'GENERIC',
};

export const settlementScheduleTypes = {
  BY_PERIOD: 'BY_PERIOD',
  BY_AMOUNT: 'BY_AMOUNT',
};

export const settlementScheduleTypeSelect = [
  { value: settlementScheduleTypes.BY_PERIOD, label: 'By period' },
  { value: settlementScheduleTypes.BY_AMOUNT, label: 'By amount' },
];

export const businessTypes = {
  GAMBLING: 'Gambling',
  FOREX: 'Forex',
  ADULT: 'Adult',
  ALTERNATIVE: 'Alternative',
  CRYPTO: 'Crypto',
  LOW_RISK: 'Low_Risk',
  PARTNER: 'Partner',
};

export const serviceTypes = {
  PLATFORM: 'PLATFORM',
  STUDIO: 'STUDIO',
};

export const legalTypes = {
  NATURAL_PERSON: 'NATURAL_PERSON',
  LEGAL_ENTITY: 'LEGAL_ENTITY',
};

export const operationTypes = {
  NATIONAL: 'NATIONAL',
  INTERNATIONAL: 'INTERNATIONAL',
};

export const businessTypeSelect = [
  { value: businessTypes.GAMBLING, label: 'Gambling' },
  { value: businessTypes.FOREX, label: 'Forex' },
  { value: businessTypes.ADULT, label: 'Adult' },
  { value: businessTypes.ALTERNATIVE, label: 'Alternative' },
  { value: businessTypes.CRYPTO, label: 'Crypto' },
  { value: businessTypes.LOW_RISK, label: 'Low Risk' },
  { value: businessTypes.PARTNER, label: 'Partner' },
];

export const serviceTypeSelect = [
  { value: serviceTypes.PLATFORM, label: 'Platform' },
  { value: serviceTypes.STUDIO, label: 'Studio' },
];

export const legalTypeSelect = [
  { value: legalTypes.NATURAL_PERSON, label: 'Natural Person' },
  { value: legalTypes.LEGAL_ENTITY, label: 'Legal Entity' },
];

export const operationTypeSelect = [
  { value: operationTypes.NATIONAL, label: 'National' },
  { value: operationTypes.INTERNATIONAL, label: 'International' },
];

export const generalStatuses = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  ANONYMOUS: 'ANONYMOUS',
  ALL: 'ALL',
};

export const generalVisibleStatuses = {
  VISIBLE: 'VISIBLE',
  INVISIBLE: 'INVISIBLE',
  ALL: 'ALL',
};

export const generalUserStatuses = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
  ALL: 'ALL',
};

export const generalStatusTypeSelect = [
  { value: generalStatuses.ALL, label: 'labelAll' },
  { value: generalStatuses.ACTIVE, label: 'statusActive' },
  { value: generalStatuses.INACTIVE, label: 'statusInactive' },
];

export const generalVisibleTypeSelect = [
  { value: generalVisibleStatuses.ALL, label: 'labelAll' },
  { value: generalVisibleStatuses.VISIBLE, label: 'Visible' },
  { value: generalVisibleStatuses.INVISIBLE, label: 'Invisible' },
];

export const AccountEnableTypeSelect = [
  { value: generalUserStatuses.ALL, label: 'All' },
  { value: generalUserStatuses.ENABLED, label: 'Enabled' },
  { value: generalUserStatuses.DISABLED, label: 'Disabled' },
];

export const maintenanceFeeOptions = {
  NO_FEE: false,
  DEFAULT_FEE: true,
};

export const maintenanceFeeOptionsSelect = [
  { value: maintenanceFeeOptions.NO_FEE, label: 'labelNoFee' },
  { value: maintenanceFeeOptions.DEFAULT_FEE, label: 'labelDefaultFee' },
];

export const transferType = [
  { value: 'CREDIT', label: 'CREDIT' },
  { value: 'DEBIT', label: 'DEBIT' },
];

export const balanceTypes = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY',
};

export const apiCredentialTypes = {
  CASHIN: 'deposit',
  CASHOUT: 'cashout',
  WEB_STATUS: 'web_status',
};

export const GLOBAL = {
  CASHOUT: 'cashout',
  CASHIN: 'cashin',
  INVALID: '__INVALID__',
  LEFT: 'left',
  RIGHT: 'right',
  INTERNAL: 'internal',
  MERCHANT: 'merchant',
  GENERIC: 'generic',
  OTHERS: 'others',
  CANCEL: 'cancel',
  IN: 'IN',
  INPUT: 'input',
  OUTPUT: 'output',
  REFUND: 'refund',
  TOP_UP: 'topUps',
  ALL: 'ALL',
  UP: 'up',
  DOWN: 'down',
  REFERRED: 'referredMerchantsList',
};

export const refundAttemptedStatus = [
  { label: 'labelAll', value: 'ALL' },
  { label: 'textYes', value: 'YES' },
  { label: 'textNo', value: 'NO' },
];

export const VocuherStatusSelect = [
  { value: Status.UPLOADED, label: 'statusUploaded' },
  { value: Status.MERCHANT_DISCARDED, label: 'statusMerchantDiscarded' },
  { value: Status.MERCHANT_ACCEPTED, label: 'statusMerchantAccepted' },
];

export const AttachmentType = {
  UPLOAD: 'UPLOAD',
  DOWNLOAD: 'DOWNLOAD',
};

export const CashoutProcessors = {
  PAYVALIDA: 188,
};

export const paymentTypes = {
  CREDIT_CARD: 'CREDIT_CARD',
};

export const TopUpStatusOptions = [
  { value: Status.PENDING, label: 'Pending' },
  { value: Status.CANCELLED, label: 'Cancelled' },
  { value: Status.WAITING_TRANSFER, label: 'WaitingTransfer' },
  { value: Status.PARTIALLY_COMPLETED, label: 'PartiallyCompleted' },
  { value: Status.COMPLETED, label: 'Completed' },
];

export const TopUpCreditOptions = {
  TOTAL: 'TOTAL',
  PARTIAL: 'PARTIAL',
};

export const ForeignAccountTypes = {
  EXPAT: 'EXPAT',
  TOP_UP: 'TOP_UP',
};

export const genericTicketTypes = {
  WITHDRAWALS: 'WITHDRAWALS',
  DEPOSITS: 'DEPOSITS',
  GENERAL: 'GENERAL',
  REVERSAL: 'REVERSAL',
  COMPLIANCE: 'COMPLIANCE',
};

export const PixBankCodes = {
  KEYDOCUMENT: 10002,
};

export const DummyAccountType = {
  SAVING: 'SAVING',
};

export const stepsName = {
  LEGAL_REPRESENTATIVE: 'Legal representative',
  COMPANY: 'Company',
  TERMS_CONDITIONS: 'Terms and Conditions',
};

export const ModalSize = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
};

export const pathFolder = {
  examples: '/examples',
};

export const fileName = {
  OlaClickTC: 'OlaclickTC',
  OrderEatTC: 'OrderEatTc.pdf',
};

export const FINANCE_FX_REGEX = /^[0-9]\d{0,5}(\.\d{1,4})?$/;
export const FINANCE_POSITIVE_AMOUNT_REGEX = /^\d{0,18}(\.\d{1,2})?$/;

// eslint-disable-next-line no-useless-escape
export const WEB_URL_REGEX = /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;

// Regular expression to match emoji
// eslint-disable-next-line max-len
export const regexExp =
  // eslint-disable-next-line max-len
  /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/i;

export const accountGroupName = {
  BANK: 'BANK',
  LOCAL_BANK: 'LOCAL_BANK',
  WALLET: 'WALLET',
};

export const localBankCountries = {
  COLOMBIA: 'Colombia',
  PERU: 'Peru',
  MEXICO: 'Mexico',
};

export const InstallmentStatus = {
  released: 'RELEASED',
  nextRelease: 'NEXT_RELEASE',
  toRelease: 'TO_RELEASE',
};

export const panelTypes = [
  { value: 'DIRECTA', label: 'Directa', display: true },
  { value: 'ONSPOT', label: 'Onspot' },
  { value: 'TUPAY', label: 'Tupay', display: true },
  { value: 'PI_BRAZIL', label: 'Pi Brasil' },
  { value: 'PI_MEXICO', label: 'Pi Mexico' },
  { value: 'PI_CRYPTO_FOREX', label: 'Pi Crypto Forex' },
  { value: 'STERBEY', label: 'Sterbey' },
  { value: 'ONEKEY_PAYMENTS', label: 'Onekey Payments', display: true },
];

export const PanelType = {
  DIRECTA: 'DIRECTA',
  POVILE: 'POVILE',
  LIME_PAY: 'LIMEPAY',
  ONSPOT: 'ONSPOT',
  TUPAY: 'TUPAY',
  PI_BRAZIL: 'PI_BRAZIL',
  PI_MEXICO: 'PI_MEXICO',
  PI_CRYPTO_FOREX: 'PI_CRYPTO_FOREX',
  STERBEY: 'STERBEY',
  ONEKEY_PAYMENTS: 'ONEKEY_PAYMENTS',
  GATEWAY_DEPOSIT: 'GATEWAY_DEPOSIT',
  ZIMO: 'ZIMO',
};

export const onlyPositiveNumbersReg = /^[0-9]*$/;

export const errorCodeUpdate = 116;

export const TimeZone = {
  UTC: 'UTC',
};

export const FIELD_EMAIL_ADDRESS = 'emailAddress';
export const FIELD_PHONE = 'phone';
export const PHONE_MAX_LENGTH_INPUT = 13;
export const EMAIL_LENGTH_INPUT = 40;

export const kycAvailableCountry = {
  BRAZIL: 'BR',
  CHILE: 'CL',
  PERU: 'PE',
};

export const kycAvailableDocumentType = {
  CPF: 'CPF',
  DNI: 'DNI',
  RUC: 'RUC',
  RUT: 'RUT',
};

const kycDocumentConfig = {
  BR: {
    CPF: {
      defaultText: '000.000.000-00',
      inputLength: 12,
      maxInputLength: 15,
      length: 14,
    },
  },

  CL: {
    RUT: {
      defaultText: '00000000-0',
      inputLength: 10,
      maxInputLength: 11,
      length: 10,
    },
  },

  PE: {
    DNI: {
      defaultText: '00000000',
      inputLength: 9,
      maxInputLength: 10,
      length: 8,
    },

    RUC: {
      defaultText: '00000000000',
      inputLength: 12,
      maxInputLength: 13,
      length: 11,
    },
  },
};

export const getKycDocumentConfig = (country, documentType) => {
  return kycDocumentConfig[country][documentType];
};

export const checkIfStringOnlyHaveNumbers = (value) => {
  const re = /^[0-9\b]+$/;
  return value === '' || re.test(value);
};

export const handleDocumentFormat = (document, validDocumentLength) => {
  let formattedDocument = document;

  if (formattedDocument.length > validDocumentLength) {
    formattedDocument = document.substring(formattedDocument.length - validDocumentLength + 1);
  }

  if (formattedDocument.length === validDocumentLength) {
    if (formattedDocument[0] !== '0') {
      return formattedDocument.slice(0, -1);
    }

    for (let index = 1; index < formattedDocument.length; index++) {
      if (formattedDocument[index] !== '0' || index === formattedDocument.length - 1) {
        return formattedDocument.slice(0, index - 1) + formattedDocument.slice(index);
      }
    }
    return formattedDocument;
  }

  for (let index = formattedDocument.length; index < validDocumentLength - 1; index++) {
    formattedDocument = `0${formattedDocument}`;
  }

  return formattedDocument;
};

const sanitizeString = (str) => str.replace(/[^a-zA-Z0-9]/g, '');

export const getStringToFormat = (originalString, inputPosition, documentTextLength) => {
  const originalStringLength = originalString.length;

  if (originalStringLength > documentTextLength + 1) {
    let positionToStartSlice = inputPosition - (originalStringLength - documentTextLength);
    if (positionToStartSlice < 0) {
      positionToStartSlice = 0;
    }
    const stringToFormat = originalString.slice(positionToStartSlice, inputPosition);
    return sanitizeString(stringToFormat);
  }
  return sanitizeString(originalString);
};

export const tierTypes = {
  TIER_ONE: 'TIER_ONE',
  TIER_TWO: 'TIER_TWO',
  RISING_STARS: 'RISING_STARS',
  TIER_THREE: 'TIER_THREE',
  LONG_TAIL: 'LONG_TAIL',
};

export const tierTypesSelect = [
  { value: tierTypes.TIER_ONE, label: 'Blue (Tier 1)' },
  { value: tierTypes.TIER_TWO, label: 'Purple (Tier 2)' },
  { value: tierTypes.RISING_STARS, label: 'Yellow (Rising Stars)' },
  { value: tierTypes.TIER_THREE, label: 'White (Tier 3)' },
  { value: tierTypes.LONG_TAIL, label: 'Green (Long Tail)' },
];

export const QUICK_PAY = 'QUICK_PAY';

export const validationMessages = {
  requiredSpanish: 'validationRequiredSpanish',
  minLength: 'validationMinLengthSpanish',
  maxLength: 'validationMaxLengthSpanish',
};

export const referralFeeOptions = {
  SEPARATE: 'SEPARATE',
  SUMMED: 'SUMMED',
};

export const defaultCountryTupay = {
  countryCode: 'PE',
  countryName: 'Peru',
  currencyCode: 'PEN',
};

export const phoneInputPropsTupay = {
  defaultCountry: 'pe',
  onlyCountries: ['pe'],
  preferredCountries: [],
};

export const TUPAY_INVALID_CAPABILITIES = [
  { subject: 'Authus', action: 'view' },
  { subject: 'Withdrawals', action: 'request_batch' },
  { subject: 'Merchant', action: 'view_accounts' },
  { subject: 'Merchant', action: 'create_account' },
];

export const PAYMENT_ORDERS_BATCH_STATUS = {
  CREATED: 0,
  PENDING: 1,
  CONFIRMED: 2,
  PROCESSING: 3,
  COMPLETED: 4,
  CANCELLED: 5,
};

export const snakeToCamelCase = (snakeStr) => {
  return snakeStr
    .toLowerCase()
    .split('_')
    .map((word, index) => (index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)))
    .join('');
};

export const findCountryByname = (countries = [], countryName) => {
  return countries.find((country) => country.countryName === countryName);
};

export const getDefaultCountryTupay = (countries = []) => {
  const defaultCountryName = defaultCountryTupay.countryName; // Usamos el nombre del país por defecto del objeto defaultCountryTupay
  const defaultCountry = findCountryByname(countries, defaultCountryName);
  if (defaultCountry) {
    return {
      countryCode: defaultCountry.country,
      countryName: defaultCountry.countryName,
      currencyCode: defaultCountry.currency,
      idCountry: defaultCountry.idCountry,
    };
  }
  return defaultCountryTupay;
};

export const PaymentTypeSelect = [
  { value: 'BANK_TRANSFER', label: t('labelBankTransfer') },
  { value: 'BANK_DEPOSIT', label: t('labelBankDeposit') },
  { value: 'CREDIT_CARD', label: t('labelCreditCard') },
  { value: 'WALLET', label: t('labelWallet') },
  { value: 'VOUCHER', label: t('labelVoucher') },
];

export const creditCardCodes = ['VI', 'VD', 'MC', 'MD', 'AE', 'DC', 'DS', 'EL', 'ELD'];

export const walletType = { TRANSACTIONAL: 'TRANSACTIONAL', PROPRIETARY: 'PROPRIETARY' };

export const timezoneOptions = [
  { value: 'UTC', label: 'UTC' },
  { value: 'UTC-3', label: 'UTC-3' }
];
